import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Clipboard } from '@capacitor/clipboard';
import { ViewWillEnter } from '@ionic/angular';
import { Subject, filter, takeUntil } from 'rxjs';
import { shopConfirmModalData } from '../bazaar';
import { ShopStore } from './shop-store';
import { FormService } from 'src/app/shared/components/form/form.service';
import {
  createToaster,
  positionType,
} from 'src/app/shared/components/modals/toaster';
import { AdmobService } from 'src/app/shared/adv/admob.service';
import { UserService } from 'src/app/auth/user.service';
import { IUser } from 'src/app/auth/auth.models';
import { ImagesService } from 'src/app/services/images.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.scss'],
})
export class ShopsComponent implements OnInit, ViewWillEnter, OnDestroy {
  @ViewChild('modal') modal;

  environment = environment;

  private destroy$ = new Subject<void>();
  toolbarData = {
    arrowRouter: '/bazaar',
    title: 'Shops',
  };
  confirmModalData = shopConfirmModalData;
  showConfirmModal = false;

  shops$ = this.shopStore.selectItems();

  isPremium = false;
  isAdmin = false;
  isMobile = this.admobService.isMobile;
  isShowPage = false;

  form: FormGroup;
  link: string;

  currentUser: IUser;

  constructor(
    private shopStore: ShopStore,
    private fb: FormBuilder,
    private fs: FormService,
    private imagesService: ImagesService,
    private userService: UserService,
    private admobService: AdmobService
  ) {}

  ngOnInit() {
    this.getUser();
    this.form = this.fb.group({ image: [null] });
    this.imagesService.imageUrls.subscribe(value => {
      value?.length ? (this.link = value[0]) : '';
    });

    this.shopStore.getItems({});
  }

  ionViewWillEnter() {
    this.isShowPage = true;
    if (this.currentUser !== this.userService.user) {
      this.ngOnInit();
    }
  }

  ionViewWillLeave() {
    this.isShowPage = false;
  }

  openModal() {
    this.showConfirmModal = true;
  }

  closeModal(e) {
    e ? (this.showConfirmModal = false) : null;
  }

  async copyLink() {
    await Clipboard.write({
      string: this.link,
    });
    createToaster(
      `Photo link copied on clipboard`,
      'success',
      positionType.BOTTOM
    );
    this.form.reset();
  }

  removeImageItem(e, i) {
    if (e) {
      this.imagesService.imageUrls.next([]);
      this.link = '';
    }
  }

  private getUser() {
    this.userService.currentUser$
      .pipe(
        takeUntil(this.destroy$),
        filter(user => !!user.uid)
      )
      .subscribe(async user => {
        this.currentUser = user;
        this.isPremium = this.userService.isPremium;
        this.isAdmin = this.userService.isAdmin;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
